import type { PublicPageGuideStep } from "@/types";

/** localStorage flag: user dismissed the first-visit castings guide */
export const CASTINGS_PAGE_GUIDE_STORAGE_KEY = "te_castings_guide_v1";

export const CASTINGS_PAGE_LEDE =
  "Convocatorias teatrales abiertas en Córdoba. Filtrá por expresión de género, elegí una convocatoria y postulate por el canal que indique cada casting.";

export const CASTINGS_PUBLIC_NEW_LEDE =
  "Completá el formulario para que otras personas vean y postulen a tu casting. Al enviarlo, será revisado por el equipo de Tercer Espacio y al validarlo, aparecerá en la lista de convocatorias activas. Nos pondremos en contacto contigo para confirmar la publicación o despejar dudas.";

export const CASTINGS_PAGE_GUIDE_TITLE = "¿Cómo funcionan los castings?";

export const CASTINGS_PAGE_GUIDE_INTRO =
  "Explorá convocatorias activas y postulate directo con quien publicó el casting.";

export const CASTINGS_PAGE_GUIDE_STEPS: readonly PublicPageGuideStep[] = [
  {
    icon: "list",
    title: "Revisá la lista",
    body: "Todas las convocatorias activas aparecen en el listado de la página.",
  },
  {
    icon: "filter",
    title: "Filtrá por expresión de género del rol",
    body: "Usá el filtro cuando busques convocatorias para un rol específico.",
  },
  {
    icon: "send",
    title: "Postulate",
    body: "Abrí una tarjeta, leé requisitos y contactá por WhatsApp, mail o Instagram.",
  },
  {
    icon: "megaphone",
    title: "O creá tu propio casting",
    body: "Si estás en búsqueda de actuantes, podés agregar tu propio casting a la lista de convocatorias.",
  },
] as const;

export const CASTINGS_PAGE_GUIDE_CONFIRM_LABEL = "Listo, ver castings";

export const CASTINGS_PAGE_GUIDE_ACTION_TRACK_SUFFIX = "castings_guide_dismiss";
